<div class="truck-container" [formGroup]="group">
  @if (groupName !== 'others') {
    <div class="truck-type">
      <div class="truck-pills">
        <div class="truck-pill" [class.selected]="group.get('van').value">
          <mat-checkbox formControlName="van" labelPosition="after" (change)="onTruckChange($event)"
            data-testid="van-type">Van</mat-checkbox>
        </div>
        <div class="truck-pill" [class.selected]="group.get('tank').value">
          <mat-checkbox formControlName="tank" labelPosition="after" (change)="onTruckChange($event)"
            data-testid="tank-type">Tank</mat-checkbox>
        </div>
        <div class="truck-pill" [class.selected]="group.get('flat').value">
          <mat-checkbox formControlName="flat" labelPosition="after" (change)="onTruckChange($event)"
            data-testid="flat-type">Flat</mat-checkbox>
        </div>
        @if (groupName === 'straightTruck') {
          <div class="truck-pill" [class.selected]="group.get('dumpTruck').value">
            <mat-checkbox formControlName="dumpTruck" labelPosition="after" (change)="onTruckChange($event)"
              data-testid="dump-type">Dump Truck</mat-checkbox>
          </div>
        }
        <div class="truck-pill" [class.selected]="group.get('reefer').value">
          <mat-checkbox formControlName="reefer" labelPosition="after" (change)="onTruckChange($event)"
            data-testid="reefer-type">Reefer</mat-checkbox>
        </div>
        <div class="truck-pill" [class.selected]="group.get('otherTruckType').value">
          <mat-checkbox formControlName="otherTruckType" labelPosition="after"
            (change)="onOtherCheckboxChange($event.checked, group)" data-testid="other-type">Other</mat-checkbox>
        </div>
      </div>
      @if (group.get('otherTruckType').value) {
        <div class="other-description-container">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Description (optional)</mat-label>
            <input matInput type="text" maxlength="100" formControlName="otherTruckTypeDescription"
              data-testid="other-description" />
          </mat-form-field>
        </div>
      }
    </div>
  }

  @if (groupName === 'others') {
    <div class="equipment-container">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Equipment</mat-label>
        <input matInput type="text" maxlength="100" formControlName="equipment"
          (input)="onEquipmentChange()"
          data-testid="equipment" />
      </mat-form-field>
    </div>
  }

  @if (checkAnyTruck) {
    <div class="truck-experience padding-left-sm">
      <div class="label">
        <label>EXPERIENCE *</label>
      </div>
      <div class="experience-inputs-grid">
        <div class="experience-input-item">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>
              Years
            </mat-label>
            <mat-select formControlName="years" (selectionChange)="onYearChange()" data-test="experience-years"
              data-testid="years">
              @for (year of years; track year) {
                <mat-option [value]="year" data-test="years" [attr.data-testid]="'year-' + year">
                  {{ year }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="experience-input-item">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>
              Months
            </mat-label>
            <mat-select formControlName="months" (selectionChange)="onMonthChange()" data-test="experience-months"
              data-testid="experience-months">
              @for (month of months; track month) {
                <mat-option [value]="month" data-test="months"
                  [attr.data-testid]="'month-' + month">
                  {{ month }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  }

  <div class="miles-info padding-left-sm">
    <mat-form-field class="full-width" appearance="outline" data-test="miles-driven">
      <mat-label>Miles Driven</mat-label>
      <mat-select formControlName="milesDriven" (selectionChange)="onMilesDrivenChange()" data-test="select-miles-driven" data-testid="miles-driven">
        @for (option of milesDrivenOptions; track option) {
          <mat-option [value]="option.name" data-test="miles"
            [attr.data-testid]="'miles-' + option?.displayName?.toLowerCase()">
            {{ option.displayName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>